import React from "react";
import { getValue } from "@utils/lodash";

function TaskDetailsSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path-task-details">
          <rect id="Rectangle_18159" data-name="Rectangle 18159" width="24" height="24" transform="translate(-11986 -7274)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_268" data-name="Mask Group 268" transform="translate(11986 7274)" clip-path="url(#clip-path-task-details)">
        <path id="task_alt_FILL0_wght300_GRAD0_opsz24" d="M13.16-7.158a9.741,9.741,0,0,1-3.9-.787,10.1,10.1,0,0,1-3.176-2.137,10.1,10.1,0,0,1-2.138-3.174,9.732,9.732,0,0,1-.788-3.9,9.74,9.74,0,0,1,.788-3.9,10.1,10.1,0,0,1,2.138-3.176A10.1,10.1,0,0,1,9.258-26.37a9.735,9.735,0,0,1,3.9-.788,9.793,9.793,0,0,1,3.147.5,10.162,10.162,0,0,1,2.723,1.395L17.887-24.1a8.616,8.616,0,0,0-2.21-1.093,8.023,8.023,0,0,0-2.518-.391A8.118,8.118,0,0,0,7.2-23.118a8.118,8.118,0,0,0-2.461,5.961A8.118,8.118,0,0,0,7.2-11.2a8.118,8.118,0,0,0,5.961,2.461A8.118,8.118,0,0,0,19.118-11.2a8.118,8.118,0,0,0,2.461-5.961,8.231,8.231,0,0,0-.073-1.1,7.5,7.5,0,0,0-.219-1.055L22.563-20.6a10.381,10.381,0,0,1,.442,1.67,10.062,10.062,0,0,1,.153,1.767,9.739,9.739,0,0,1-.787,3.9,10.1,10.1,0,0,1-2.137,3.175,10.1,10.1,0,0,1-3.174,2.138,9.734,9.734,0,0,1-3.9.788Zm-1.5-5.522L7.555-16.79,8.664-17.9l3,3L22.049-25.3l1.109,1.109L11.664-12.68Z" transform="translate(-11987.158 -7244.842)" fill="#5f6368"/>
      </g>
    </svg>
  );
}

export default TaskDetailsSvgComponent;
